import React, { useEffect, useState } from 'react';
import { Dialog } from "evergreen-ui";
import { Input, message } from "antd";
import { useListVals } from "../../Firebase/databaseHooks";
import Firebase from "../../Firebase/Firebase";
import {
    read, utils
} from "xlsx";
import FireFetch from "../../Firebase/FireFetch";
import { getDatabase, ref, update } from "firebase/database";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { useAuth } from "../../AuthContext/AuthContext";



const db = getDatabase(Firebase);
const moment = require("moment");
var auth = getAuth(Firebase)
const CommunityUploadModal = (props) => {
    const { canAccessModule } = useAuth();
    const canCreateAdminConfig = canAccessModule("ADMIN_CONFIGS", "create");

    const [file, setFile] = useState(null);
    const [users] = useListVals(ref(db, "talmidsdb/users"));
    const [organisations] = useListVals(ref(db, "talmidsdb/organisations"));
    const [districts] = useListVals(ref(db, "talmidsdb/districts"));
    const [countries] = useListVals(ref(db, "talmidsdb/Countries"));
    const [userID, setUserID] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        //setShowModal(props.showModal);
        onAuthStateChanged(auth, function (user) {
            if (user) {
                setUserID(user.uid);
            }
        })
    }, [props]);

    const handleFileUpload = (e) => {
        setFile(e.target.files[0]);
    }
    const arrayToObject = (array) =>
        array.reduce((obj, item) => {
            obj[item[`${props.id}ID`]] = item
            return obj
        }, {});

    function readFile() {
        if (!canCreateAdminConfig) {
            message.error("You do not have permission to upload communities.");
            setLoading(false);
            return;
        }
        if (!file) {
            message.error("Please select a file to upload.");
            setLoading(false);
            return;
        }

        const reader = new FileReader();
        reader.onload = (evt) => {
            // evt = on_file_select event
            /* Parse data */
            const bstr = evt.target.result;
            const wb = read(bstr, { type: "binary" });
            /* Get first worksheet */
            const wsname = wb.SheetNames[0];
            const ws = wb.Sheets[wsname];
            /* Convert array of arrays */
            const data = utils.sheet_to_csv(ws, { header: 1 });
            /* Update state */

            const dataArray = FireFetch.convertToJson(data);
            var tempArray = dataArray.map((item) => {
                /*
                var newObject = {};
                Object.keys(item).forEach((key) => {
                    var newKey = key.split(" ").length > 1 ? key.split(" ")[0].toLowerCase() + "" + key.split(" ")[1] :
                        key.split(" ")[0].toLowerCase();
                    newObject[newKey] = item[key] ? item[key] : "";
                });

                 */
                return item;
            });
            console.log(tempArray);
            tempArray = tempArray.filter(x => x.community !== "");
            tempArray.map((item) => {

                if (item.community !== "") {

                    item[`${props.id}ID`] = Array(12).fill("ABCDEFGHIJKLMNOPQRSTUVWXYZ123456789abcdefghijklmnopqrstuvwxyz")
                        .map(function (x) { return x[Math.floor(Math.random() * x.length)] }).join('');

                    item.name = item.community
                    item.responsibleUserID = users.find(x => (x.firstname + " " + x.surname)?.toLowerCase() === item.responsibleUser?.toLowerCase()) ?
                        users.find(x => (x.firstname + " " + x.surname)?.toLowerCase() === item.responsibleUser?.toLowerCase()).id : "";
                    item.createdBy = userID;
                    item.createdDate = moment().format("YYYY-MM-DDTh:mm:ss");
                    item.startDate = moment(item.date).add(1, 'days').format("YYYY-MM-DD");
                    item.countryID = countries.find(x => (x.name)?.toLowerCase() === item.countryId?.toLowerCase()) ?
                        item.countryId + "-" + countries.find(x => (x.name)?.toLowerCase() === item.countryId?.toLowerCase()).alpha3Code : "";
                    item.organisationID = organisations.find(x => (x.name)?.toLowerCase() === item.orgID?.toLowerCase()) ?
                        organisations.find(x => (x.name)?.toLowerCase() === item.orgID?.toLowerCase()).orgID : "";
                    item.district = districts.find(x => (x.district)?.toLowerCase() === item.district?.toLowerCase()) ?
                        districts.find(x => (x.district)?.toLowerCase() === item.district?.toLowerCase()).districtID : "";
                    item.salesforceID = "";
                    item.latitude = 0.0; item.longitude = 0.0;
                    item.inactivationDate = ""; item.notes = ""; item.zone = "";

                    delete item.action;
                    delete item.id; delete item.community;
                    delete item.key; delete item.date;
                    delete item.countryId;
                    delete item.organisation;
                    delete item.orgID;
                    delete item.created;
                    delete item.responsibleUser;
                }

            })

            const arrayObjects = arrayToObject(tempArray);
            console.log(arrayObjects)

            update(ref(db, "talmidsdb/communities"), arrayObjects).then(() => {
                message.success("Communities uploaded successfully");
                props.setShowModal(false);
                setLoading(false);
            }).catch((error) => {
                message.error(error);
                setLoading(false);
            });


        };
        reader.readAsBinaryString(file);
    }


    return (
        <>
            <Dialog
                isShown={props.showModal}
                title="Upload Communities"
                onCloseComplete={() => { props.setShowModal(false) }}
                onConfirm={() => {
                    setLoading(true);
                    readFile();
                }}
                isConfirmDisabled={!canCreateAdminConfig || !file}
                isConfirmLoading={loading}
            >
                <div>
                    <Input
                        type="file"
                        style={{ width: "100%" }}
                        accept=".xlsx, .xls, .csv"
                        placeholder="select excel file"
                        size="large"
                        className="mt-2 w-100"
                        disabled={!canCreateAdminConfig}
                        onChange={handleFileUpload} />
                </div>

            </Dialog>

        </>
    )
}

export default CommunityUploadModal;
